/*
 * @providesModule DialogV3
 */

import {PropsWithChildren} from 'react';
import {TouchableOpacity, View, ViewStyle, StyleSheet} from 'react-native';
import {stylesFn} from './DialogV3.styles';
import SkillzImage from 'SkillzImage';
import SkillzStyle from 'SkillzStyle';
import ConfettiView from 'ConfettiView';

const {textColorPrimary} = SkillzStyle.fullStyles;

type DialogV3Props = PropsWithChildren<{
  headerImageComponent?: JSX.Element;
  badgeComponent?: JSX.Element;
  showBadge?: boolean;
  showCloseButton?: boolean;
  headerContainerStyles?: ViewStyle;
  /**
   * (Optional) If true, confetti animation will be shown in the dialog. Default is false.
   */
  showConfetti?: boolean;
  onClose?: () => void;
  confettiStyles?: ViewStyle;
  dialogBoxStyle?: ViewStyle;
  headerStyle?: ViewStyle;
  contentStyle?: ViewStyle;
  confettiStyle?: ViewStyle;
}>;
export function DialogV3({
  headerImageComponent,
  showCloseButton = true,
  showConfetti = false,
  headerContainerStyles,
  children,
  onClose,
  badgeComponent,
  showBadge = false,
  confettiStyles,
  dialogBoxStyle,
  headerStyle,
  contentStyle,
  confettiStyle,
}: DialogV3Props) {
  const styles = stylesFn();

  return (
    <View style={styles.fullScreenContainer}>
      <ConfettiView
        style={[
          styles.confetti,
          StyleSheet.absoluteFill,
          confettiStyles,
          confettiStyle,
        ]}
        avoidFront={false}
        shouldPlay={showConfetti}
      >
        <View style={[styles.dialogBox, dialogBoxStyle]}>
          <View style={[styles.headerContainer, headerContainerStyles, headerStyle]}>
            {showBadge && badgeComponent && badgeComponent}
            {showCloseButton && (
              <TouchableOpacity onPress={() => onClose?.()} style={styles.rightIconButton}>
                <SkillzImage
                  source={'close_button_icon.svg'}
                  style={styles.rightIcon}
                  tintColor={'#2A3333'}
                />
              </TouchableOpacity>
            )}
            {headerImageComponent}
          </View>
          <View style={[styles.contentContainer, contentStyle]}>
            {children}
          </View>
        </View>
      </ConfettiView>
    </View>
  );
}
